import type { TealiumViewEvent } from 'src/app/utils/analytics/utils/getViewEventDataByPage/type';
import type { TrackingEvent } from 'src/types/trackingData';

type Config = Record<string, any>;

type Window = {
  __CONFIG__?: Config;
  isImpersonating?: boolean;
  location: any;
  uiv?: () => void;
  cypressTracker?: ({
    eventName,
    data,
  }: TrackingEvent | TealiumViewEvent) => void;
  hj?: (method: string, eventName: string) => void;
  hjBootstrapCalled?: string[];
  Cypress?: any;
  SEEK_TEST?: boolean;
};

type Globals = {
  window: Window;
};

export default Object.defineProperty({}, 'window', {
  // @ts-ignore
  get: (): Window => (typeof window === 'undefined' ? ({} as Window) : window),
}) as Globals;
